module.exports = __webpack_public_path__ + "static/events-header-bfaf5f050f9c3ee3affb65717f7a8b43.jpg";